import React from "react";

import { PreviewLayout } from ".";
import { QRProps } from "@/contexts/QREditorContext/types";

export default function PreviewText(props: QRProps<"text">) {
  const { message } = props?.data ?? { message: "" };
  const isInitPreview = props?.initPreview;
  return (
    <PreviewLayout
      page="text"
      dataQA="preview-text-container"
      includeBrowser
      isInitPreview={isInitPreview}>
      <div className="qr-text-container">
        <div className="qr-text-message">{message}</div>
      </div>
    </PreviewLayout>
  );
}
